export const serverConstants = {
    DOMAIN_NAME: '' || "https://alien-dimension-api.herokuapp.com/api",
    REDIRECTION_BASE_URL : "http://localhost:3000/#/" //   ||  https://test-e07e2.web.app/#/

}